// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedProduct {
  LiveLessons: {"enum_constant":"LiveLessons"};
  LiveLessonsNative: {"enum_constant":"LiveLessonsNative"};
  StudyAbroad: {"enum_constant":"StudyAbroad"};
  iKnow: {"enum_constant":"iKnow"};
}

export type ProductId = keyof IParsedProduct;
export type ProductData = IParsedProduct[ProductId];
const data: ProductData[] = [{"enum_constant":"LiveLessons"},{"enum_constant":"LiveLessonsNative"},{"enum_constant":"StudyAbroad"},{"enum_constant":"iKnow"}];
export default data;
